<template>
  <div class="home">
    <iframe :src="html" id="gameIframe" style="width: 100vw; height: 100vh;"></iframe>
    <div class="popup" v-if="showPay">
      <pay ref="pay" @close="closePay" :payInfo="payInfo" @order-created="handleOrderCreated" @payment-method-change="handlePaymentMethodChange" @alipay="setAlipay"></pay>
    </div>
    <div class="popup" style="z-index: 20" v-if="showAliPay">
      <iframe :src="payUrl" id="alipay" style="width: 100vw; height: 100vh;"></iframe>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import pay from "./pay";
import alipay from './alipay';
import { Toast } from 'vant';
import { payAPI, queryPaymentResult } from '@/services/api';

export default {
  name: "HomeView",
  components: {
    pay,
    alipay
  },
  data() {
    return {
      html: "",
      showPay: false,
      showAliPay: false,
      payInfo: {
        amount: 0,
        orderId: '',
        orderTime: '',
        source: '欢乐电玩城',
        productId: '',
        isCreatingOrder: false
      },
      orderData: null,
      selectedPaymentMethod: 'alipay', // 默认支付宝支付
      messageHandlers: {
        // 处理支付请求
        buyItem: this.handlePayRequest,
        logout: this.handleLogout,
        alipayScuccess: this.handleAliPayScuccess,
      },
      payUrl: ''
    };
  },
  watch: {
    showAliPay(newValue, oldValue) {
      console.log('showAliPay', newValue, oldValue)
      if (!newValue) {
        clearTimeout(this.payResultTime)
        this.sendMessageToGame({
          type: 'payResult',
          data: {}
        });
      }
    }
  },
  methods: {
    // 初始化游戏URL
    initGameUrl() {
      console.log('initGameUrl')
      let token = localStorage.getItem("token");
      let pathname = window.location.pathname
      this.payUrl = `${pathname}static/alipay.html`
      let query = this.$route.query;
      let channelKey = ''
      const urlParams = new URLSearchParams(window.location.search);
      const newChannelKey = urlParams.get('channelKey');
      const newCode = urlParams.get('code');
      const newAgentId = urlParams.get('agentId');
      if (query || newChannelKey) {
        let cookie = document.cookie.split(';')
        let promotion_link_code = ''
        for (let i = 0; i < cookie.length; i++) {
          let item = cookie[i].split('=')
          if (item[0].trim() === 'promotion_link_code') {
            promotion_link_code = item[1]
          }
          if (item[0].trim() === 'promotion_channel_key') {
            channelKey = item[1]
          }
          console.log('cookie', item[0].trim(), item[1])
        }
        if ((query.code || newCode) && (!promotion_link_code || promotion_link_code === 'undefined')) {
          document.cookie = `promotion_agent_id=${query.agentId || newAgentId || ''}`
          document.cookie = `promotion_link_code=${query.code || newCode || ''}`
          document.cookie = `promotion_channel_key=${query.channelKey || newChannelKey || 'maokong'}`
        }
        if (!channelKey || channelKey == 'null' || channelKey === 'undefined') {
          channelKey = query.channelKey || newChannelKey || 'maokong'
          document.cookie = `promotion_channel_key=${query.channelKey || newChannelKey || 'maokong'}`
        }
        console.log('channelKey', channelKey)
      }
      if (token) {
        this.html = `${pathname}static/index.html?token=${token}&gameName=欢乐电玩城&channelKey=${channelKey}&coinType=0&uiskin4=0&scoreType=1&kefuurl=${encodeURIComponent('http://kefu.maokongai.cn/chat/mobile?source=mk')}`
      } else {
        // 未登录，跳转到登录页
        this.$router.push('/login');
      }
    },

    // 处理来自iframe的消息
    handleIframeMessage(event) {
      // console.log("接收到子页面传递的值：", event);

      try {
        // 尝试解析消息数据
        const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;

        // 检查消息格式
        if (!message.action) {
          // console.error('收到无效消息格式:', message);
          return;
        }

        console.log('收到消息:', message);

        // 根据消息类型调用对应的处理函数
        const handler = this.messageHandlers[message.action];
        if (handler) {
          handler(message.data);
        } else {
          console.warn('未知消息类型:', message.action);
        }
      } catch (error) {
        console.error('处理iframe消息出错:', error);

        // 如果是简单字符串消息，直接显示
        if (typeof event.data === 'string') {
          console.log('显示简单字符串消息:', event.data);
          console.log('A1')
          // Toast(event.data);
        }
      }
    },

    handleLogout() {
      // 清除本地存储的token
      localStorage.removeItem("token");
      // 跳转到登录页
      this.$router.push('/login');
    },

    handleAliPayScuccess() {
      this.showAliPay = false;
      this.showPay = false;
      this.sendMessageToGame({
        type: 'payResult',
      })
    },

    // 处理支付方式变更
    handlePaymentMethodChange(method) {
      console.log('支付方式变更:', method);
      this.selectedPaymentMethod = method;

      // 如果已经创建了订单，但支付方式变更了，需要重新创建订单
      if (this.orderData && this.orderData.payType !== this.getPayTypeCode(method)) {
        // this.recreateOrder();
      }
    },

    // 获取支付类型代码
    getPayTypeCode(method) {
      return method === 'wechat' ? 1 : 2; // 1-微信支付，2-支付宝支付
    },

    // 重新创建订单
    async recreateOrder() {
      this.payInfo.isCreatingOrder = true;
      try {
        await this.createOrder();
      } catch (error) {
        console.error('重新创建订单失败:', error);
      }
    },

    // 处理支付请求
    async handlePayRequest(data) {
      console.log('收到支付请求:', data);
      let productId = 0;
      if (data.mark == '周卡' || data.mark == '月卡') {
        productId = `card:${data.id}`;
      } else {
        productId = `option:${data.id}`
      }
      // 更新支付信息
      this.payInfo = {
        productId: productId,
        amount: data.money || 0,
        title: data.title || '',
        detail: data.detail || '',
        desc: data.desc || '',
        price: data.price || 0,
        isCreatingOrder: true
      };

      // 显示支付页面
      this.showPay = true;

      // 创建订单
      try {
        await this.createOrder();
      } catch (error) {
        console.error('创建订单失败:', error);
        // 错误处理已在createOrder方法中完成
      }
    },

    // 创建订单
    async createOrder() {
      if (!this.payInfo.productId) {
        Toast.fail('商品ID不能为空');
        return;
      }

      try {
        // 创建订单参数 - 只传递productId和payType
        const orderParams = {
          productId: this.payInfo.productId,
          // payType: this.getPayTypeCode(this.selectedPaymentMethod)
        };

        console.log('创建订单参数:', orderParams);

        // 调用创建订单API
        const response = await payAPI.createOrder(orderParams);
        console.log('创建订单响应:', response);
        if (response.data.code == 0 || response.data.errCode === 0) {
          // 订单创建成功
          this.orderData = response.data.data;

          // 更新支付信息
          this.payInfo = {
            ...this.payInfo,
            price: this.orderData.amount || this.payInfo.price,
            orderId: this.orderData.orderId || this.payInfo.orderId,
            orderTime: this.orderData.createTime || this.payInfo.orderTime,
            isCreatingOrder: false
          };

          // 通知支付组件订单已创建
          if (this.$refs.pay) {
            this.$refs.pay.setOrderData(this.orderData);
          }

          return this.orderData;
        } else {
          // 订单创建失败
          console.log('A3')
          Toast.fail(response.data.message || '创建订单失败');
          this.payInfo.isCreatingOrder = false;
          this.showPay = false;
          this.sendMessageToGame({
            type: 'payResult',
            data: {
              success: false,
              cancelled: true,
              orderId: this.payInfo.orderId,
              productId: this.payInfo.productId
            }
          });
          return null;
        }
      } catch (error) {
        console.error('创建订单出错:', error);
        console.log('A4')
        Toast.fail('网络错误，请稍后重试');
        this.payInfo.isCreatingOrder = false;
        this.sendMessageToGame({
          type: 'payResult',
        });
        this.showPay = false;

        return null;
      }
    },

    // 处理订单创建成功
    handleOrderCreated(orderData) {
      console.log('订单创建成功:', orderData);
      this.orderData = orderData;
    },

    // 关闭支付页面
    closePay(result) {
      this.showPay = false;
      this.orderData = null;

      // 如果支付成功，通知游戏页面
      if (result && result.success) {
        this.sendMessageToGame({
          type: 'payResult',
          data: {
            success: true,
            orderId: this.payInfo.orderId,
            productId: this.payInfo.productId,
            ...result
          }
        });
      } else if (result && result.cancelled) {
        // 用户取消支付
        this.sendMessageToGame({
          type: 'payResult',
          data: {
            success: false,
            cancelled: true,
            orderId: this.payInfo.orderId,
            productId: this.payInfo.productId
          }
        });
      }
    },

    // 向游戏iframe发送消息
    sendMessageToGame(message) {
      const iframe = document.getElementById('gameIframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          typeof message === 'object' ? JSON.stringify(message) : message,
          '*'
        );
      }
    },

    // 触发支付宝支付
    setAlipay(message, orderId) {
      console.log('订单号', orderId)
      console.log('触发支付宝支付:', message);
      let loading = Toast.loading({
        message: '正在拉起支付...',
        forbidClick: true,
        duration: 0
      });
      this.showAliPay = true;
      const _ = this

      setTimeout(() => {
        const iframe = document.getElementById('alipay');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage(JSON.stringify({
            type: 'alipay',
            data: message
          }), '*');
          _.getPayResult(orderId)
        }
        loading.close()
        // this.$refs.aliPay.init(e);
      }, 1000);
    },

    getPayResult(id) {
      console.log('获取支付结果')
      this.payResultTime = setTimeout(() => {
        payAPI.queryPaymentResult(id).then(res => {
          console.log('支付结果', res.data.data)
          if (res.data.data.payStatus === 1) {
            Toast.success('支付成功')
            this.showPay = false;
            this.sendMessageToGame({
              type: 'payResult',
              data: {
                success: false,
                cancelled: true,
                orderId: this.payInfo.orderId,
                productId: this.payInfo.productId
              }
            });
          } else if (res.data.data.payStatus === 3) {
            Toast.success('支付失败')
            this.showPay = false;
            this.sendMessageToGame({
              type: 'payResult',
              data: {
                success: false,
                cancelled: true,
                orderId: this.payInfo.orderId,
                productId: this.payInfo.productId
              }
            });
          } else {
            this.getPayResult(id)
          }
        })
      }, 5000)
    },
  },



  // created() {
  //   console.log("首页")
  //   this.initGameUrl();
  // },
  activated() {
    console.log("首页2")
    this.initGameUrl();
    window.addEventListener("message", this.handleIframeMessage);
  },
  // mounted() {
  //   // 添加消息监听器
  //   console.log("首页1")
  //   window.addEventListener("message", this.handleIframeMessage);
  //   // window.history.forward();
  //   // setInterval(function () {
  //   //   window.history.forward();
  //   // }, 100);
  // },
  beforeDestroy() {
    // 移除消息监听器
    window.removeEventListener("message", this.handleIframeMessage);
  }
};
</script>

<style scoped>
.home {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
